// eslint-disable-next-line import/no-anonymous-default-export
export default {
    apiHost: (process.env.REACT_APP_API_HOST || 'http://localhost:5000'),
    apiPath: (process.env.REACT_APP_API_PATH || '/api/v1'),
    wsPath: (process.env.REACT_APP_WS_PATH || '/socket.io'),
}